import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en';
import fr from './fr';

Vue.use(VueI18n);

interface LanguageObject {
  [key: string]: string | undefined;
}

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en, fr },
});

const languageobj = (
  key?: VueI18n.Path,
  params?: {
    choice?: VueI18n.Choice;
    locale?: VueI18n.Locale;
    values?: (string | LanguageObject | undefined)[];
  },
  options?: {
    additional_locales?: VueI18n.Locale[];
  }
): LanguageObject => {
  let obj: LanguageObject = {};

  const locales = Object.keys(i18n.messages).concat(
    options?.additional_locales || []
  );

  locales.forEach((locale) => {
    if (key) {
      obj[locale] = i18n.tc(
        key,
        params?.choice || 1,
        locale,
        params?.values?.map((value) =>
          value
            ? typeof value === 'object'
              ? value[locale]
              : value
            : undefined
        )
      );
    } else {
      obj[locale] = '';
    }
  });

  return obj;
};
Vue.prototype.$languageobj = languageobj;

const languageobjArray = (
  keys: (string | LanguageObject)[]
): LanguageObject => {
  const obj: LanguageObject = {};
  const locales = Object.keys(i18n.messages);
  locales.forEach((locale) => {
    obj[locale] = keys
      .map((key) => (typeof key === 'object' ? key[locale] : languageobj(key)))
      .join(', ');
  });
  return obj;
};
Vue.prototype.$languageobjArray = languageobjArray;

export default i18n;

export { LanguageObject, languageobj, languageobjArray };
